import React from 'react';
import { Alert, Box, CircularProgress } from '@mui/material';
import { Navigate } from 'react-router-dom';

import { useSalonAccess } from '../../../context/SalonAccessContext';
import { firstPermittedProfessionalRoute } from './SalonPermissionGate';

const SalonClientMessagesGate = ({ children }) => {
  const {
    selectedSalon,
    selectedSalonId,
    hasPermission,
    canSee,
    isLoading,
    isError,
  } = useSalonAccess();
  if (isLoading) return <Box sx={{ display: 'grid', placeItems: 'center', py: 8 }}><CircularProgress /></Box>;
  if (isError) return <Alert severity="error">Impossible de charger les accès.</Alert>;
  const allowed = Boolean(
    selectedSalon?.is_owner
    || (selectedSalonId && hasPermission(selectedSalonId, 'client_messages.access')),
  );
  if (!allowed) return <Navigate to={firstPermittedProfessionalRoute(canSee)} replace />;
  return children;
};

export default SalonClientMessagesGate;
